import { render, staticRenderFns } from "./moreBox.vue?vue&type=template&id=beff2b5c&scoped=true&"
import script from "./moreBox.vue?vue&type=script&lang=js&"
export * from "./moreBox.vue?vue&type=script&lang=js&"
import style0 from "./moreBox.vue?vue&type=style&index=0&id=beff2b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beff2b5c",
  null
  
)

export default component.exports